import { lineSpinner } from "ldrs";

export default function PageSection({ style }) {
  lineSpinner.register();
  return (
    <div style={style}>
      <l-line-spinner
        size="40"
        stroke="3"
        speed="1"
        color="#5664d2"
      ></l-line-spinner>
    </div>
  );
}
